var _path, _mask, _path2, _path3, _mask2, _path4, _path5, _mask3, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStocksLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 57,
    viewBox: "0 0 61 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1106 54.5842H1.81445",
    stroke: "#EBF3FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_17170_88587",
    maskUnits: "userSpaceOnUse",
    x: 2.22168,
    y: 30.4443,
    width: 13,
    height: 19,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2.22168,
    y: 30.4443,
    width: 13,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22168 32.7443C4.22168 32.5787 4.35599 32.4443 4.52168 32.4443H12.5883C12.754 32.4443 12.8883 32.5787 12.8883 32.7443V46.8888H4.22168V32.7443Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22168 32.7443C4.22168 32.5787 4.35599 32.4443 4.52168 32.4443H12.5883C12.754 32.4443 12.8883 32.5787 12.8883 32.7443V46.8888H4.22168V32.7443Z",
    fill: "#EBF3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8883 46.8888V48.8888H14.8883V46.8888H12.8883ZM4.22168 46.8888H2.22168V48.8888H4.22168V46.8888ZM4.52168 34.4443H12.5883V30.4443H4.52168V34.4443ZM10.8883 32.7443V46.8888H14.8883V32.7443H10.8883ZM12.8883 44.8888H4.22168V48.8888H12.8883V44.8888ZM6.22168 46.8888V32.7443H2.22168V46.8888H6.22168ZM12.5883 34.4443C11.6495 34.4443 10.8883 33.6832 10.8883 32.7443H14.8883C14.8883 31.4741 13.8586 30.4443 12.5883 30.4443V34.4443ZM4.52168 30.4443C3.25142 30.4443 2.22168 31.4741 2.22168 32.7443H6.22168C6.22168 33.6832 5.46056 34.4443 4.52168 34.4443V30.4443Z",
    fill: "#EBF3FF",
    mask: "url(#path-2-outside-1_17170_88587)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-2_17170_88587",
    maskUnits: "userSpaceOnUse",
    x: 23.8887,
    y: 11.6667,
    width: 13,
    height: 38,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 23.8887,
    y: 11.6667,
    width: 13,
    height: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8887 13.9667C25.8887 13.8011 26.023 13.6667 26.1887 13.6667H34.2553C34.421 13.6667 34.5553 13.8011 34.5553 13.9667V46.889H25.8887V13.9667Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8887 13.9667C25.8887 13.8011 26.023 13.6667 26.1887 13.6667H34.2553C34.421 13.6667 34.5553 13.8011 34.5553 13.9667V46.889H25.8887V13.9667Z",
    fill: "#EBF3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5553 46.889V48.889H36.5553V46.889H34.5553ZM25.8887 46.889H23.8887V48.889H25.8887V46.889ZM26.1887 15.6667H34.2553V11.6667H26.1887V15.6667ZM32.5553 13.9667V46.889H36.5553V13.9667H32.5553ZM34.5553 44.889H25.8887V48.889H34.5553V44.889ZM27.8887 46.889V13.9667H23.8887V46.889H27.8887ZM34.2553 15.6667C33.3165 15.6667 32.5553 14.9056 32.5553 13.9667H36.5553C36.5553 12.6965 35.5256 11.6667 34.2553 11.6667V15.6667ZM26.1887 11.6667C24.9184 11.6667 23.8887 12.6965 23.8887 13.9667H27.8887C27.8887 14.9056 27.1276 15.6667 26.1887 15.6667V11.6667Z",
    fill: "#EBF3FF",
    mask: "url(#path-4-outside-2_17170_88587)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-3_17170_88587",
    maskUnits: "userSpaceOnUse",
    x: 45.5547,
    y: 0.111084,
    width: 13,
    height: 49,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 45.5547,
    y: 0.111084,
    width: 13,
    height: 49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5547 2.41108C47.5547 2.2454 47.689 2.11108 47.8547 2.11108H55.9214C56.087 2.11108 56.2214 2.2454 56.2214 2.41108V46.8889H47.5547V2.41108Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5547 2.41108C47.5547 2.2454 47.689 2.11108 47.8547 2.11108H55.9214C56.087 2.11108 56.2214 2.2454 56.2214 2.41108V46.8889H47.5547V2.41108Z",
    fill: "#EBF3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2214 46.8889V48.8889H58.2214V46.8889H56.2214ZM47.5547 46.8889H45.5547V48.8889H47.5547V46.8889ZM47.8547 4.11108H55.9214V0.111084H47.8547V4.11108ZM54.2214 2.41108V46.8889H58.2214V2.41108H54.2214ZM56.2214 44.8889H47.5547V48.8889H56.2214V44.8889ZM49.5547 46.8889V2.41108H45.5547V46.8889H49.5547ZM55.9214 4.11108C54.9825 4.11108 54.2214 3.34997 54.2214 2.41108H58.2214C58.2214 1.14082 57.1916 0.111084 55.9214 0.111084V4.11108ZM47.8547 0.111084C46.5844 0.111084 45.5547 1.14082 45.5547 2.41108H49.5547C49.5547 3.34997 48.7936 4.11108 47.8547 4.11108V0.111084Z",
    fill: "#EBF3FF",
    mask: "url(#path-6-outside-3_17170_88587)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocksLight);
export default __webpack_public_path__ + "static/media/stocks-light.f6919bb7.svg";
export { ForwardRef as ReactComponent };